import { useSelectedEntity } from '../../../hooks/useSelectedEntity/useSelectedEntity';
import { useNonAccountEntityUsers } from '../useUserEntities/useUserEntities';

export const usePaymentsEnabledOwnEntity = () => {
  const { entityUsers } = useNonAccountEntityUsers();
  const { entity } = useSelectedEntity();

  return entityUsers?.some(
    (user) => user.paymentsEnabled && !!entity?.taxNumber
  );
};
